import axios from 'axios';

// When loaded as file:// (packaged Electron app) relative URLs don't work —
// we always point directly at the local Express server.
// In dev the React proxy (package.json "proxy") handles /api → 5000.
const BASE = 'https://ems.ourschool.lk/api';
// const BASE = 'http://localhost:5000/api';

const api = axios.create({ baseURL: BASE });

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('ec_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('ec_token');
      localStorage.removeItem('ec_user');
      window.location.href = '/';
    }
    return Promise.reject(err);
  }
);

export default api;
